import React from 'react';

function Footer() {
  return (
    <div>
        <div>
        {/* /.content-wrapper */}
        <footer className="main-footer">
          <strong>Copyright ©{new Date().getFullYear()} CRM Expo Property </strong>
          All rights reserved.
          <div className="float-right d-none d-sm-inline-block">
            <b>Version</b> 2.0.0
          </div>
        </footer>
        {/* Control Sidebar */}
        <aside className="control-sidebar control-sidebar-dark">
          {/* Control sidebar content goes here */}
        </aside>
        {/* /.control-sidebar */}
      </div>
    </div>
  );
}

export default Footer;
